import * as React from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'
import classNames from 'classnames/bind'

import { track } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { FirstStepVideo } from 'modules/onboarding/lib/firstSteps/types'

import styles from './index.module.scss'

const cx = classNames.bind(styles)
interface Props {
  images: string[]
  thumbs: string[]
  video?: FirstStepVideo
}

const ImagesGallery = ({ images, thumbs, video }: Props) => {
  const [contentType, setContentType] = React.useState<string>(!video ? 'image' : 'video')
  const [imageShown, setImageShown] = React.useState<number>(0)
  const [playVideo, setPlayVideo] = React.useState<boolean>(false)

  if (!images || !images.length) {
    return null
  }

  const handlePlayVideo = () => {
    setPlayVideo(true)
    track('Watch first steps video', { section: video?.section, source: 'apps-video' })
  }

  return (
    <div className={styles.wrap}>
      {contentType === 'image' ? (
        <div className={styles.mainContainer}>
          <img src={images[imageShown]} alt="Image" key={imageShown} />
        </div>
      ) : (
        <>
          {!playVideo ? (
            <div className={styles.mainContainer}>
              <div className={styles.videoOverlay}>
                <Box
                  flexDirection="row"
                  justifyContent="center"
                  alignItems="center"
                  height="full"
                  onClick={handlePlayVideo}
                >
                  <Box gap="s16" alignItems="center">
                    <Box className={styles.videoOverlayButton}>
                      <Icon.Medium icon="play" color="grey1000" />
                    </Box>
                    <Box className={styles.videoOverlayTag}>
                      {i18n.t('app_store_v2.common.watch_video')}
                    </Box>
                  </Box>
                </Box>
              </div>
              <img src={video?.thumb} alt="Image" />
            </div>
          ) : (
            <div className={styles.videoContainer}>
              {video && (
                <iframe
                  src={`https://fast.wistia.net/embed/iframe/${video.video_id}?videoFoam=true&autoPlay=true`}
                  allow="fullscreen"
                ></iframe>
              )}
            </div>
          )}
        </>
      )}
      <div className={styles.thumbsContainer}>
        {video?.thumb && (
          <div
            className={cx('thumbContainer', {
              selected: contentType === 'video',
            })}
          >
            <div className={styles.videoThumbOverlay}>
              <Box flexDirection="row" justifyContent="center" alignItems="center" height="full">
                <Icon.Medium icon="play" color="grey000White" />
                <Text size="200" color="grey200" weight="bold">
                  {i18n.t('app_store_v2.common.video')}
                </Text>
              </Box>
            </div>
            <img
              src={video.thumb}
              onClick={() => {
                setPlayVideo(false)
                setContentType('video')
              }}
            />
          </div>
        )}
        {thumbs.slice(0, 4).map((_path, index) => (
          <div
            key={index}
            className={cx('thumbContainer', {
              selected: index === imageShown && contentType === 'image',
            })}
          >
            <img
              src={thumbs[index]}
              onClick={() => {
                setContentType('image')
                setImageShown(index)
              }}
            />
          </div>
        ))}
      </div>
    </div>
  )
}

export default ImagesGallery
